const activeConfig = {
  activeStartTime1: '2022/05/20 15:00:00',
  // 活动结束时间
  activeEndTime1: '2022/05/20 17:00:00',

  activeStartTime2: '2022/03/15 15:00:00',
  // 活动结束时间
  activeEndTime2: '2022/03/15 17:00:00',

  activeStartTime3: '2022/03/18 15:00:00',
  // 活动结束时间
  activeEndTime3: '2022/03/18 17:00:00',

  // 详情请求时间
  detailTime1: '2022-03-09',
  detailTime2: '2022-03-15',
  detailTime3: '2022-03-18',

  // 首页小浮标
  iconTimeStart: '2022/03/7 9:00:00',
  iconTimeEnd: '2022/03/18 17:00:00',

  // 首页弹窗
  popStartTime1: '2022/03/7 9:00:00',
  // 活动结束时间
  popEndTime1: '2022/03/9 17:00:00',

  popStartTime2: '2022/03/14 9:00:00',
  // 活动结束时间
  popEndTime2: '2022/03/15 17:00:00',

  popStartTime3: '2022/03/17 9:00:00',
  // 活动结束时间
  popEndTime3: '2022/03/18 17:00:00',

  // producIdList:[330,331,326,327,328,329,332,333,334]

  producIdList: [101243, 101247, 101244, 101245, 101248, 101249, 101250, 101251, 101246],
};
export default activeConfig;



// WEBPACK FOOTER //
// ./src/activityConfig/index.js